import {getApkDownloadBaseUrl} from "@/lib/utils/apkDownload";

/** Query param that asks the site to start the APK download (see ApkAutoDownload). */
export const APK_DOWNLOAD_PARAM = "download";
export const APK_DOWNLOAD_VALUE = "apk";

/**
 * Link to the Android build: apk-service (AC-900), not a static file, so the APK
 * can carry the partner mark. Render it as `href` only — the click itself must go
 * through `useApkDownload`, which adds `click`/`traffic` (and the AC-903 login
 * code); a bare static APK would lose the partner of a player who then registers
 * in the app. Empty when the environment has no apk-service.
 */
export const getApkUrl = (): string => getApkDownloadBaseUrl();
